import { useMemo } from "react"
import { ConnectionHandler } from "relay-runtime"
import { chPatientEpisodesOfCareQuery$data } from "@/modules/patients/services/ch/__generated__/chPatientEpisodesOfCareQuery.graphql"
import { dePatientEpisodesOfCareQuery$data } from "@/modules/patients/services/de/__generated__/dePatientEpisodesOfCareQuery.graphql"

export const useEmptyEpisodesOfCareData = (
  patientEpisodesOfCareRef: dePatientEpisodesOfCareQuery$data | chPatientEpisodesOfCareQuery$data,
  patientId: string,
) => {
  const emptyEpisodesData = useMemo(() => {
    const episodeIdsToDelete: string[] = []
    const connectionId = ConnectionHandler.getConnectionID(
      "client:root",
      "RootEpisodesOfCareConnection_patientEpisodesOfCare",
      { patientId },
    )

    if (patientEpisodesOfCareRef.patientEpisodesOfCare?.edges) {
      for (const patientEpisodeOfCareEdge of patientEpisodesOfCareRef.patientEpisodesOfCare.edges) {
        const episodeOfCare = patientEpisodeOfCareEdge.node

        const progressNotesEdges = episodeOfCare.progressNotes?.edges || []
        const hasNoProgressNotes = progressNotesEdges.length === 0

        if (hasNoProgressNotes && !episodeOfCare.isVirtual) {
          episodeIdsToDelete.push(episodeOfCare.id)
        }
      }
    }

    return { episodeIdsToDelete, connectionId }
  }, [patientEpisodesOfCareRef.patientEpisodesOfCare?.edges, patientId])

  return emptyEpisodesData
}
